import React, { Profiler } from 'react';
import { handleStoreDetailsProfilerRender, isStoreDetailsRenderProfilingEnabled } from '../../features/storeDetails/overview/utils/storeDetailsRenderProfiling';

type StoreDetailsRenderProfilerProps = {
    id: string;
    children: React.ReactNode;
};

const StoreDetailsRenderProfiler: React.FC<StoreDetailsRenderProfilerProps> = ({ id, children }) => {
    if (!isStoreDetailsRenderProfilingEnabled()) {
        return <>{children}</>;
    }

    return (
        <Profiler id={id} onRender={handleStoreDetailsProfilerRender}>
            {children}
        </Profiler>
    );
};

export default React.memo(StoreDetailsRenderProfiler);
